<div class="view-container">
  <div class="filters">

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Company" matInput [formControl]="companyControl" [matAutocomplete]="companyAuto" (focus)="loadFilterCompanyOptions()">
          <button mat-button *ngIf="companyNameFilter || companyControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearCompany()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #companyAuto="matAutocomplete" (optionSelected)="onCompanySelected($event)">

            <mat-option *ngIf="loadingFilterOption; else notLoadingCompanies" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingCompanies>
              <mat-option *ngIf="!loadingFilterOption && !(filteredCompanies | async)?.length" disabled>
                No items
              </mat-option>

              <mat-option *ngFor="let company of filteredCompanies | async" [value]="company.name">
                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <img class="company-logo" *ngIf="company?.companyLogoUrl" [lazyLoad]="company.companyLogoUrl" [matTooltip]="company.name" />
                    <span [class.default-value]="isDefaultId(company.id)" [innerHtml]="company.name | encodeHtml | highlight: companyControl.value"></span>
                  </div>
              </mat-option>
            </ng-template>

          </mat-autocomplete>
        </mat-form-field>
      </form>

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Brand" matInput [formControl]="brandControl" [matAutocomplete]="brandAuto" (focus)="loadFilterBrandOptions()">
          <button mat-button *ngIf="brandNameFilter || brandControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearBrand()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #brandAuto="matAutocomplete" (optionSelected)="onBrandSelected($event)" [displayWith]="displayBrandName">

            <mat-option *ngIf="loadingFilterOption; else notLoadingBrands" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingBrands>
              <mat-option *ngIf="!(filteredBrands | async)?.length" disabled>
                No items
              </mat-option>

              <mat-option *ngFor="let brand of filteredBrands | async" [value]="brand.id">
                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <img class="brand-logo" *ngIf="brand?.brandLogoUrl" [lazyLoad]="brand.brandLogoUrl" [matTooltip]="brand.name" />
                    <span [class.default-value]="isDefaultId(brand.id)" [innerHtml]="brand.name | encodeHtml | highlight: brandControl.value"></span>
                  </div>
              </mat-option>
            </ng-template>

          </mat-autocomplete>
        </mat-form-field>
      </form>

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Shared Range" matInput [formControl]="productRangeControl" [matAutocomplete]="productRangeAuto" (focus)="loadFilterProductRangeOptions()">
          <button mat-button *ngIf="productRangeNameFilter || productRangeControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearProductRange()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #productRangeAuto="matAutocomplete" (optionSelected)="onProductRangeSelected($event)" [displayWith]="displayRange">

            <mat-option *ngIf="loadingFilterOption; else notLoadingProductRanges" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingProductRanges>
              <mat-option *ngIf="!(filteredProductRanges | async)?.length" disabled>
                No items
              </mat-option>

              <mat-option *ngFor="let productRange of filteredProductRanges | async" [value]="productRange">
                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <img class="company-logo" *ngIf="productRange?.companyLogoUrl" [lazyLoad]="productRange.companyLogoUrl" [matTooltip]="productRange.companyName" />
                    <span *ngIf="!productRange?.companyLogoUrl">{{ productRange.companyName }}</span>
                    <span [class.default-value]="isDefaultId(productRange.id)" class="text-info" [innerHtml]="productRange.name | encodeHtml | highlight: productRangeControl.value"></span>
                  </div>
              </mat-option>
            </ng-template>

          </mat-autocomplete>
        </mat-form-field>
      </form>
        
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Product Classification" matInput [formControl]="productClassificationControl" [matAutocomplete]="productClassificationAuto" (focus)="loadFilterProductClassificationOptions()">
          <button mat-button *ngIf="productClassificationNameFilter || productClassificationControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearProductClassification()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #productClassificationAuto="matAutocomplete" (optionSelected)="onProductClassificationSelected($event)">

            <mat-option *ngIf="loadingFilterOption; else notLoadingProductClassifications" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingProductClassifications>
              <mat-option *ngIf="!(filteredProductClassifications | async)?.length" disabled>
                No items
              </mat-option>

              <mat-option *ngFor="let productClassification of filteredProductClassifications | async" [value]="productClassification.name">
                  <div class="w-100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <span [innerHtml]="productClassification.name | encodeHtml | highlight: productClassificationControl.value"></span>
                  </div>
              </mat-option>
            </ng-template>

          </mat-autocomplete>
        </mat-form-field>
      </form>

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Product Type" matInput [formControl]="productTypeControl" [matAutocomplete]="productTypeAuto" (focus)="loadFilterProductTypeOptions()">
          <button mat-button *ngIf="productTypeNameFilter || productTypeControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearProductType()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #productTypeAuto="matAutocomplete" (optionSelected)="onProductTypeSelected($event)">

            <mat-option *ngIf="loadingFilterOption; else notLoadingProductTypes" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingProductTypes>
              <mat-option *ngIf="!(filteredProductTypes | async)?.length" disabled>
                No items
              </mat-option>

              <mat-option *ngFor="let productType of filteredProductTypes | async" [value]="productType.name">
                  <div class="w-100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <span [innerHtml]="productType.name | encodeHtml | highlight: productTypeControl.value"></span>
                  </div>
              </mat-option>
            </ng-template>

          </mat-autocomplete>
        </mat-form-field>
      </form>

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Product State" matInput [formControl]="productStateControl" [matAutocomplete]="productStateAuto" (focus)="loadFilterProductStateOptions()">
          <button mat-button *ngIf="productStateNameFilter || productStateControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearProductState()">
            <mat-icon>close</mat-icon>
          </button>

          <mat-autocomplete #productStateAuto="matAutocomplete" (optionSelected)="onProductStateSelected($event)">

            <mat-option *ngIf="loadingFilterOption; else notLoadingProductStates" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingProductStates>
              <mat-option *ngIf="!(filteredProductStates | async)?.length" disabled>
                No items
              </mat-option>

              <mat-option *ngFor="let productState of filteredProductStates | async" [value]="productState.name">
                  <div class="w-100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <product-workflow-icon id="workflow-state-list-icon"
                      [workflowStateType]="productState.stateType">
                    </product-workflow-icon>
                    <span [innerHtml]="productState.name | encodeHtml | highlight: productStateControl.value"></span>
                  </div>
              </mat-option>
            </ng-template>

          </mat-autocomplete>

        </mat-form-field>
      </form>

    </div>

    <div *ngIf="productTypeIdFilter" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">
      <product-specification-filter
        fxFlex="100"
        [productTypeId]="productTypeIdFilter"
        [selectedSpecificationIds]="productSpecificationSelectedIds"
        (filterGroupsChange)="onProductSpecificationFilterGroupsChange($event)"
        (selectedSpecificationIdsChange)="onProductSpecificationSelectedIdsChange($event)">
      </product-specification-filter>
    </div>

    <div class="filter" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" fxLayout.lt-sm="column">
      <mat-form-field class="accent">
          <mat-label>Search all {{ this.totalCount }} products</mat-label>
          <input matInput type="text" name="searchTerm" placeholder="Search {{ this.totalCount }} products"
              [(ngModel)]="searchTerm"
              (ngModelChange)="debounceSearchTermChanged()"
              (keyup.esc)="clearSearchTerm()">
          <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearchTerm()">
              <mat-icon>close</mat-icon>
          </button>
      </mat-form-field>

      <div fxLayout="column" fxLayoutAlign="center start">

        <ng-container *ngIf="isSituUser">
          <mat-slide-toggle [(ngModel)]="enabledProductsFilter" (change)="onEnabledProductsFilter()">Enabled Products</mat-slide-toggle>
        </ng-container>

        <ng-container *ngIf="allowRequestedProducts">
          <mat-slide-toggle [(ngModel)]="requestedProductsFilter" (change)="onRequestedProductsFilter()">Requested Products</mat-slide-toggle>
        </ng-container>

        <mat-slide-toggle [(ngModel)]="orderByDateModified" (change)="loadProducts(true)">Show Latest</mat-slide-toggle>

      </div>

      <button mat-mini-fab color="accent" style="box-shadow: none;" [disabled]="loading || !hasFilters" (click)="onClearAllFilters()" matTooltip="Clear Filters">
        <mat-icon>filter_alt_off</mat-icon>
      </button>
    </div>

  </div>

  <mat-card class="contrast" *ngIf="multiSelect">
    <mat-card-content>
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div fxLayoutAlign="start center" fxLayoutGap="20px">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
              <button mat-icon-button color="accent" *ngIf="!hasSelectedAllProducts()" (click)="selectAllProducts(true)" matTooltip="Select All">
                <mat-icon>select_all</mat-icon>
              </button>
              <button mat-icon-button color="accent" *ngIf="hasSelectedAllProducts()" (click)="selectAllProducts(false)" matTooltip="Deselect All">
                <mat-icon>deselect</mat-icon>
              </button>
              {{ getSelectedProductCount() }} Selected {{ pluralize("Product", getSelectedProductCount()) }}.
            </div>

            <button mat-flat-button color="basic" (click)="loadAllProducts()" [disabled]="!hasMoreProductsToShow()">
              Load All {{ this.totalCount }} Products
            </button>
          </div>

          <div>
            <button mat-flat-button color="primary" (click)="chooseSelectProducts()" [disabled]="getSelectedProductCount() === 0">
              Select {{ pluralize("Product", getSelectedProductCount()) }}
            </button>
          </div>
        </div>
    </mat-card-content>
  </mat-card>

  <mat-card>
      <mat-card-content>
          <div class="product-expanded-image-container" fxLayout="row wrap" fxLayoutAlign="center center">
              <ng-container *ngFor="let item of products">
                  <thumb-product-card
                      [item]="item"
                      [selectedCompanyId]="selectedCompany?.id"
                      [isCatalog]="isCatalog"
                      [editProductOnClick]="editProductOnClick"
                      [searchTerm]="searchTerm"
                      [canExpandImage]="isCatalog"
                      (click)="onSelectProduct(item); $event.stopPropagation()"
                      [situView]="SituViewUrl"
                      [selected]="isSelectedProduct(item)"
                      [productTypeColor]="getProductTypeColor(item?.productTypeId)"
                      [productTypeName]="getProductTypeName(item?.productTypeId)"
                      [companyName]="getCompanyName(item?.companyId)"
                      [companyLogo]="getCompanyLogo(item?.companyId)"
                      (filterCompanyId)="selectCompanyByProductCompanyId($event)"
                      (filterProductTypeId)="selectProductTypeByProduct($event)"
                      (shareSituLink)="share($event)"
                      (createPreview)="getPreview($event)"
                      (productDownloadRequest)="onProductDownloadRequest($event)">
                  </thumb-product-card>
              </ng-container>
              
              <ng-container *ngFor="let item of requestedProducts">
                
                <mat-card class="contrast requested-product-card" [class.banner-info]="isSelectedProduct(item)" (click)="onSelectProduct(item)">
                    <mat-card-content class="h-100">
                      <div class="h-100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                        <div class="requested-product-thumbnail" fxLayout="row" fxLayoutAlign="center center">
                          <mat-icon class="requested-product-icon">kitchen</mat-icon>
                          <mat-icon class="overlay-requested-product-icon text-purple">pending</mat-icon>
                        </div>
                        <div fxLayout="column" fxLayoutAlign="center start">

                          <img *ngIf="getCompanyLogo(item?.supplierId)" class="requested-product-supplier-logo" [lazyLoad]="getCompanyLogo(item?.supplierId)">

                          <div *ngIf="!getCompanyLogo(item?.supplierId)" class="requested-product-supplier-name">
                            {{ item?.supplierId ? getCompanyName(item.supplierId) : 'No Supplier Assigned' }}
                          </div>

                          <div>
                            {{item.name}}
                          </div>
                          <div>
                            <small>
                              {{item.productCode}}
                            </small>
                          </div>
                          
                        </div>
                      </div>
                      
                    </mat-card-content>
                </mat-card>
              </ng-container>

              <div *ngIf="!loading && products.length === 0 && requestedProducts.length === 0" fxFlex="100" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
                <div>No Products Found...</div>
                <button mat-flat-button color="accent" (click)="onClearAllFilters()"> Clear Filters </button>
              </div>
              <div #showMoreProductsMarker fxFlex="100" fxLayout="row" fxLayoutAlign="center center">
                  <button *ngIf="hasMoreProductsToShow()" mat-flat-button color="accent" (click)="showMoreProducts()" [disabled]="loading"> {{ loading ? "Loading" : "Show" }} more products </button>
              </div>
          </div>
      </mat-card-content>
  </mat-card>
</div>
